import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/animal-debt/Creative-Solutions.webp";

function Creativesolutionanimal() {
  return (
    <section
      className="creative-solution-animal p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#007F6E" }}>
              Creative Solutions & Seamless Implementation
            </h2>
            <h3 style={{ color: "#202020" }}>
              How TekRevol Brought Animal Debt Disaster to Life
            </h3>
          </Col>
        </Row>
        <Row className="mt-4 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h4 style={{ color: "#202020" }}>Our Approach</h4>
            <ul>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="42"
                  fill="none"
                  viewBox="0 0 41 42"
                >
                  <path
                    fill="#00806F"
                    d="M18.165 25.818c-.3-.023-.58-.163-.78-.39l-4.679-4.679a1.17 1.17 0 0 1 1.56-1.56l3.852 3.853 13.304-13.21a1.17 1.17 0 0 1 1.56 1.56L18.945 25.428a1.15 1.15 0 0 1-.78.39"
                  ></path>
                  <path
                    fill="#00806F"
                    d="M20.504 34.788A14.04 14.04 0 0 1 8.23 27.52 13.6 13.6 0 0 1 6.561 22.2a14.04 14.04 0 0 1 7.175-13.74 13.6 13.6 0 0 1 5.318-1.669 13.9 13.9 0 0 1 5.537.53 1.17 1.17 0 1 1-.671 2.23 11.9 11.9 0 0 0-4.679-.436c-1.555.158-3.062.63-4.43 1.388a11.7 11.7 0 0 0-3.43 2.87 11.57 11.57 0 0 0-2.558 8.593 11.5 11.5 0 0 0 1.388 4.43 11.7 11.7 0 0 0 2.87 3.43 11.57 11.57 0 0 0 8.593 2.559 11.5 11.5 0 0 0 4.43-1.388 11.7 11.7 0 0 0 3.43-2.87 11.57 11.57 0 0 0 2.559-8.594 1.23 1.23 0 0 1 2.448-.234 14.04 14.04 0 0 1-7.19 13.74 13.6 13.6 0 0 1-5.396 1.748z"
                  ></path>
                </svg>
                We embraced the absurd. Every feature in Animal Debt Disaster
                was designed to be unconventional and unpredictable, tapping
                into creative stupidity without overcomplicating the gameplay.
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="42"
                  fill="none"
                  viewBox="0 0 41 42"
                >
                  <path
                    fill="#00806F"
                    d="M18.165 25.818c-.3-.023-.58-.163-.78-.39l-4.679-4.679a1.17 1.17 0 0 1 1.56-1.56l3.852 3.853 13.304-13.21a1.17 1.17 0 0 1 1.56 1.56L18.945 25.428a1.15 1.15 0 0 1-.78.39"
                  ></path>
                  <path
                    fill="#00806F"
                    d="M20.504 34.788A14.04 14.04 0 0 1 8.23 27.52 13.6 13.6 0 0 1 6.561 22.2a14.04 14.04 0 0 1 7.175-13.74 13.6 13.6 0 0 1 5.318-1.669 13.9 13.9 0 0 1 5.537.53 1.17 1.17 0 1 1-.671 2.23 11.9 11.9 0 0 0-4.679-.436c-1.555.158-3.062.63-4.43 1.388a11.7 11.7 0 0 0-3.43 2.87 11.57 11.57 0 0 0-2.558 8.593 11.5 11.5 0 0 0 1.388 4.43 11.7 11.7 0 0 0 2.87 3.43 11.57 11.57 0 0 0 8.593 2.559 11.5 11.5 0 0 0 4.43-1.388 11.7 11.7 0 0 0 3.43-2.87 11.57 11.57 0 0 0 2.559-8.594 1.23 1.23 0 0 1 2.448-.234 14.04 14.04 0 0 1-7.19 13.74 13.6 13.6 0 0 1-5.396 1.748z"
                  ></path>
                </svg>
                The game used puzzles that were simple enough to be accessible
                but with unexpected twists to keep the challenge interesting.
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="42"
                  fill="none"
                  viewBox="0 0 41 42"
                >
                  <path
                    fill="#00806F"
                    d="M18.165 25.818c-.3-.023-.58-.163-.78-.39l-4.679-4.679a1.17 1.17 0 0 1 1.56-1.56l3.852 3.853 13.304-13.21a1.17 1.17 0 0 1 1.56 1.56L18.945 25.428a1.15 1.15 0 0 1-.78.39"
                  ></path>
                  <path
                    fill="#00806F"
                    d="M20.504 34.788A14.04 14.04 0 0 1 8.23 27.52 13.6 13.6 0 0 1 6.561 22.2a14.04 14.04 0 0 1 7.175-13.74 13.6 13.6 0 0 1 5.318-1.669 13.9 13.9 0 0 1 5.537.53 1.17 1.17 0 1 1-.671 2.23 11.9 11.9 0 0 0-4.679-.436c-1.555.158-3.062.63-4.43 1.388a11.7 11.7 0 0 0-3.43 2.87 11.57 11.57 0 0 0-2.558 8.593 11.5 11.5 0 0 0 1.388 4.43 11.7 11.7 0 0 0 2.87 3.43 11.57 11.57 0 0 0 8.593 2.559 11.5 11.5 0 0 0 4.43-1.388 11.7 11.7 0 0 0 3.43-2.87 11.57 11.57 0 0 0 2.559-8.594 1.23 1.23 0 0 1 2.448-.234 14.04 14.04 0 0 1-7.19 13.74 13.6 13.6 0 0 1-5.396 1.748z"
                  ></path>
                </svg>
                To make sure it appealed to influencers, the game’s fun factor
                was amplified with deliberate ridiculousness, making it a
                perfect fit for streamers and YouTubers.
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Creativesolutionanimal;
